
import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative min-h-screen w-full overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/c322681462555ec7b960c183058bece0.jpg"
          alt="London Skyline"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>

      <div className={`relative z-10 h-full min-h-screen max-w-7xl mx-auto px-6 flex flex-col justify-center pt-20 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-2 bg-[#C9A961]/20 backdrop-blur-sm border border-[#C9A961]/30 rounded-full mb-6">
            <span className="text-[#C9A961] text-sm font-medium">Trusted London Travel Partner</span>
          </div>

          <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Visit London
          </h1>

          <h2 className="text-2xl lg:text-3xl text-[#C9A961] mb-6 font-light" style={{ fontFamily: 'Playfair Display, serif' }}>
            Tailored Services for Overseas Pakistanis Visiting the UK
          </h2>

          <p className="text-lg text-white/90 mb-8 leading-relaxed max-w-2xl">
            Navigating London&apos;s expensive hospitality market requires strategic planning for visiting families seeking affordability without sacrificing comfort. We bypass mainstream booking platforms to identify hidden, budget-friendly hotels offering essential amenities.
          </p>

          <p className="text-base text-white/80 mb-10 leading-relaxed max-w-2xl">
            From halal dining proximity to spacious room configurations, we ensure maximum value and cultural convenience for travelers maximizing their stay on a budget.
          </p>

          <div className="flex flex-wrap gap-4">
            <button 
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="px-8 py-4 bg-[#C9A961] text-white rounded-lg text-base font-semibold hover:bg-[#B89851] transition-all flex items-center gap-2 shadow-lg whitespace-nowrap cursor-pointer"
            >
              Plan Your London Visit
              <i className="ri-arrow-right-line"></i>
            </button>
            <a 
              href="#services"
              className="px-8 py-4 bg-transparent border-2 border-white text-white rounded-lg text-base font-semibold hover:bg-white hover:text-gray-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Services
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-8 text-white/5 text-8xl font-bold pointer-events-none" style={{ fontFamily: 'Arial, sans-serif' }}>
        LONDON
      </div>
    </section>
  );
}
